export type ReportsTourApi = {
  ensureScope: () => Promise<void>;
  ensureCurrentTab: () => void;
  openCreateDraftModal: () => void;
  closeCreateDraftModal: () => void;
  /**
   * Creates a real OPORD draft for the selected scope, exactly as pressing
   * Create draft would. Resolves once the request has settled.
   */
  confirmCreateDraft: () => Promise<void>;
  /**
   * Closes the template dialog and opens a draft already in progress. Resolves
   * true when one was opened.
   */
  openExistingDraft: () => boolean;
  /** Draft card the tour created: open / close its header kebab. */
  openDraftKebab: () => void;
  closeDraftKebab: () => void;
  /** True when the org uses one card per report instead of the three tabs. */
  isReportVersioning: () => boolean;
};

let api: Partial<ReportsTourApi> = {};

export function registerReportsTourApi(
  partial: Partial<ReportsTourApi>
): () => void {
  api = { ...api, ...partial };
  return () => {
    for (const key of Object.keys(partial) as (keyof ReportsTourApi)[]) {
      if (api[key] === partial[key]) {
        delete api[key];
      }
    }
  };
}

export function getReportsTourApi(): Partial<ReportsTourApi> {
  return api;
}
